import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { DropdownList } from "react-widgets";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
  CustomInput,
} from "reactstrap";
import { itemTypeOptions } from "constants/ticketConstants";

function EditItemModal(props) {
  const [name, setName] = useState(props.editData.name);
  const [dropLoad, setDropLoad] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedItemType, setSelectedItemType] = useState({});

  useEffect(() => {
    setDropLoad(true);
    setSelectedItemType(
      itemTypeOptions.find((c) => c.value === props.editData.itemType)
    );
    GetApiActionWithAuthorization("coin-tickets/get-all-coin-items-categories")
      .then((res) => {
        setDropLoad(false);
        setCategories(res.data);
        setSelectedCategory(
          res.data.find((c) => c.id === props.editData.category)
        );
      })
      .catch((err) => { 
        setDropLoad(false);
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  }, []);

  const updateItemHandler = (e) => {
    let body = {
      id: props.editData.id,
      name: name.trim(),
      category: selectedCategory.id,
      itemType: selectedItemType.value,
      selectedItemType: props.activeTabLabel
    };
    PostApiWithAuthorizationAction("coin-tickets/update-coin-item", body)
      .then((res) => {
        //toast.success(res.message);
        props.addUpdatedData(res.data, props.activeTabLabel);
        props.toggle();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } else {
          toast.error("Something went wrong! /n Please clear and retry", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };

  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Add new item</ModalHeader>
      <ModalBody>
        <FormGroup className="mb-0">
          <Label className="form-control-label" for="b_name">
            Name
          </Label>
          <Input
          id="name"
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
        <FormGroup className="mb-0">
          <Label className="form-control-label" for="b_name">
            Type
          </Label>
          <DropdownList
          id="itemType"
            data={itemTypeOptions}
            busy={dropLoad}
            placeholder="Item Type"
            textField="label"
            value={selectedItemType}
            onChange={(e) => setSelectedItemType(e)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
        <FormGroup className="mb-0">
          <Label className="form-control-label" for="b_name">
            Category
          </Label>
          <DropdownList
          id="category"
            data={categories}
            busy={dropLoad}
            placeholder="Category Name"
            textField="categoryName"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
        id="update-btn"
          color="primary"
          onClick={updateItemHandler}
          disabled={name.length === 0}
        >
          Update
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditItemModal;
